"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
require("reflect-metadata");
const result_1 = require("@leavy/result");
const FlagFromLogMeta_1 = require("../decorator/FlagFromLogMeta");
const LogLevel_1 = require("./LogLevel");
class Logger {
    constructor() {
        this.rawLogCollectors = [];
        this.processedLogCollectors = [];
    }
    trace(message, meta) {
        this.innerLog(LogLevel_1.LogLevel.Trace, message, meta);
    }
    debug(message, meta) {
        this.innerLog(LogLevel_1.LogLevel.Debug, message, meta);
    }
    info(message, meta) {
        this.innerLog(LogLevel_1.LogLevel.Info, message, meta);
    }
    warn(message, meta) {
        this.innerLog(LogLevel_1.LogLevel.Warn, message, meta);
    }
    error(message, meta) {
        this.innerLog(LogLevel_1.LogLevel.Error, message, meta);
    }
    fatal(message, meta) {
        this.innerLog(LogLevel_1.LogLevel.Fatal, message, meta);
    }
    innerLog(level, message, meta) {
        const log = {
            level: level,
            message: message,
            meta: meta,
        };
        this.callRawCollector(log);
        log.meta = this.processFromLogMetadata(meta);
        this.log(log);
        this.callProcessedCollector(log);
    }
    processFromLogMetadata(model) {
        if (model == null)
            return undefined;
        const seenObjects = [];
        const process = (currentModel) => {
            if (this.isObject(currentModel)) {
                const clone = this.cloneModel(currentModel);
                const metadata = Reflect.getMetadata(FlagFromLogMeta_1.FLAG_FROM_LOG_META_SYM, currentModel);
                if (metadata) {
                    seenObjects.push(currentModel);
                    Object.keys(clone).forEach((key) => {
                        if (metadata[key]) {
                            if (metadata[key] === "omit") {
                                delete clone[key];
                            }
                            else if (metadata[key] === "obfuscate") {
                                clone[key] = `[${key}]`;
                            }
                        }
                        if (this.isObject(clone[key])) {
                            if (seenObjects.includes(clone[key])) {
                                clone[key] = "[circular]";
                            }
                            else {
                                seenObjects.push(clone[key]);
                                clone[key] = process(clone[key]);
                            }
                        }
                    });
                }
                return clone;
            }
            else
                return undefined;
        };
        return process(model);
    }
    cloneModel(model) {
        if (model instanceof Error) {
            const clone = {};
            const keys = ["name", "message", "stack", ...Object.keys(model)];
            for (const k of keys) {
                clone[k] = model[k];
            }
            return clone;
        }
        return Object.assign({}, model);
    }
    callRawCollector(log) {
        this.rawLogCollectors.forEach(x => {
            x.collect(log);
        });
    }
    callProcessedCollector(log) {
        this.processedLogCollectors.forEach(x => {
            x.collect(log);
        });
    }
    isObject(x) {
        return (typeof x === "object" ? x !== null :
            typeof x === "function");
    }
    addRawLogCollector(collector) {
        if (this.rawLogCollectors.includes(collector)) {
            return result_1.Bad("COLLECTOR_ALREADY_REGISTERED");
        }
        this.rawLogCollectors.push(collector);
        return result_1.Ok();
    }
    removeRawLogCollector(collector) {
        const index = this.rawLogCollectors.indexOf(collector);
        if (index === -1) {
            return result_1.Bad("COLLECTOR_NOT_FOUND");
        }
        this.rawLogCollectors.splice(index, 1);
        return result_1.Ok();
    }
    addProcessedLogCollector(collector) {
        if (this.processedLogCollectors.includes(collector)) {
            return result_1.Bad("COLLECTOR_ALREADY_REGISTERED");
        }
        this.processedLogCollectors.push(collector);
        return result_1.Ok();
    }
    removeProcessedLogCollector(collector) {
        const index = this.processedLogCollectors.indexOf(collector);
        if (index === -1) {
            return result_1.Bad("COLLECTOR_NOT_FOUND");
        }
        this.processedLogCollectors.splice(index, 1);
        return result_1.Ok();
    }
}
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map